import { RESET_MESSAGE, SET_MESSAGE } from '../Actions';


// alert messages
export const resetMessage = (message) => ({
    type: RESET_MESSAGE,
    payload: message
});
export const setMessage = (message) => ({
    type: SET_MESSAGE,
    payload: message
});
